import { DialogPlugin } from 'tdesign-vue';
import i18n, { IsLocalLanguageType, LanguageSettingParam, i18n_t, i18n_td } from '@/locales/i18n';
import storage from '@/renderer/scripts/utils/storage';
import { IS_BROWSER, IS_DEV } from '@/common/constant/platform';
import ipc, { IpcEvents } from '@/renderer/scripts/utils/ipc';

function setLanguageInternal(lang: string | undefined, init: boolean) {
  if (lang && IsLocalLanguageType(lang) && lang !== i18n.locale) {
    if (init) {
      i18n.locale = lang;
    } else {
      storage.set(storage.StoreKey.LANGUAGE_SETTING, { language: lang });
    }
  }
}

export function setLanguage(lang: string | undefined) {
  if (lang && IsLocalLanguageType(lang) && lang !== i18n.locale) {
    const dialog = DialogPlugin.confirm({
      theme: 'info',
      header: i18n_t('提示'),
      placement: 'center',
      cancelBtn: `${i18n_t('取消')}(${i18n_td('取消', lang)})`,
      confirmBtn: `${i18n_t('确认')}(${i18n_td('确认', lang)})`,
      destroyOnClose: true,
      body: h => {
        const currentLangTip = h(
          'p',
          IS_BROWSER
            ? i18n_t('更换语言需要刷新页面，是否确认更换?')
            : i18n_t('更换语言需要重新启动腾讯云企业网盘，是否确认更换?'),
        );
        const targetLangTip = h(
          'p',
          IS_BROWSER
            ? i18n_td('更换语言需要刷新页面，是否确认更换?', lang)
            : i18n_td('更换语言需要重新启动腾讯云企业网盘，是否确认更换?', lang),
        );
        return h('div', [currentLangTip, targetLangTip]);
      },

      async onConfirm() {
        if (dialog.hide) {
          dialog.hide();
        }
        setLanguageInternal(lang, false);
        if (IS_BROWSER || IS_DEV) {
          window.location.reload();
        } else {
          ipc.send(IpcEvents.RESTART);
        }
      },
      onClose: () => {
        if (dialog.hide) {
          dialog.hide();
        }
      },
    });
  }
}

function getOSLanguageSetting() {
  const systemLanguage = navigator.language;
  if (systemLanguage) {
    logger.ui('system language: ', systemLanguage);
    switch (systemLanguage.toLowerCase()) {
      case 'zh':
      case 'zh-cn':
      case 'zh-tw':
      case 'zh-hk':
        i18n.locale = 'zh-CN';
        break;
      default:
        i18n.locale = 'en-US';
    }
  }
}

export function initLanguageSetting() {
  const { language } = storage.get(storage.StoreKey.LANGUAGE_SETTING) as LanguageSettingParam;
  if (language && IsLocalLanguageType(language)) {
    setLanguageInternal(language, true);
  } else {
    getOSLanguageSetting();
  }
}
